import { languages, noteGenerationLanguages, spellingFormats } from '../constants/languages';

const defaultInput = languages.find(option => option.value === 'zh-HK');
const choice = (value, options, fallback) => {
  const cleaned = typeof value === 'string' ? value.trim() : '';
  return options.includes(cleaned) ? cleaned : fallback;
};

// input_language is JSONB, but older clients saved a JSON-encoded string in it.
// Read both formats and keep the existing write format for compatibility.
export function normalizeLanguagePreferences(record) {
  let input = record?.input_language;
  if (typeof input === 'string') {
    try { input = JSON.parse(input); } catch { input = null; }
  }
  const inputCode = typeof input?.value === 'string' ? input.value.trim() : '';
  return {
    input_language: languages.find(option => option.value === inputCode) || defaultInput,
    output_language: choice(record?.output_language, noteGenerationLanguages, 'English'),
    spelling_format: choice(record?.spelling_format, spellingFormats, 'US English'),
  };
}

export function languagePreferencesForStorage(record) {
  const normalized = normalizeLanguagePreferences(record);
  return { ...normalized, input_language: JSON.stringify(normalized.input_language) };
}
